module.exports = __webpack_public_path__ + "img/arrowImg.da24e526.png";